import { FC } from "react";

import { BranchCode } from "api/risk";

import { InsuredCopropertyCard } from "./insured-entity-card/InsuredCopropertyCard";
import { InsuredLegalProtectionCard } from "./insured-entity-card/InsuredLegalProtectionCard";
import { InsuredPropertyCard } from "./insured-entity-card/InsuredPropertyCard";
import { InsuredUnemploymentCard } from "./insured-entity-card/InsuredUnemploymentCard";
import { ParcEntityCard } from "./parc/ParcEntityCard";

/**
 * Stratégie de carte d'entité de l'en-tête tarificateur : un seul point résout le "kind"
 * (parc, sinon branche), puis lookup dans la map. Chaque carte est auto-portée (elle gère
 * sa propre action d'édition), ce qui évite les conditions `isParc` dispersées dans l'écran.
 */
export type PricingEntityKind = "parc" | BranchCode;

const ENTITY_CARDS: Partial<Record<PricingEntityKind, FC>> = {
  parc: ParcEntityCard,
  [BranchCode.UPI]: InsuredPropertyCard,
  [BranchCode.RGI]: InsuredPropertyCard,
  [BranchCode.Unemployment]: InsuredUnemploymentCard,
  [BranchCode.Mri]: InsuredCopropertyCard,
  [BranchCode.LegalProtection]: InsuredLegalProtectionCard,
};

export const resolvePricingEntityCard = (isParc: boolean, branchCode?: BranchCode): FC | undefined =>
  ENTITY_CARDS[isParc ? "parc" : (branchCode as PricingEntityKind)];
